<div class="select-none truncate">
  <span *ngIf="isShowTop === true">
    <span>{{ metric.topLabel | capitalize }}</span>

    <span class="ml-[5px]">-</span>
  </span>

  <span
    [ngClass]="{
      'ml-[5px]': isShowTop === true
    }"
    >{{ metric.partNodeLabel | capitalize }}</span
  >

  <span class="ml-2 font-semibold">{{
    metric.partFieldLabel | capitalize
  }}</span>

  <span *ngIf="isShowTime === true" class="text-s400">
    <span class="ml-2">by {{ metric.timeNodeLabel | capitalize }}</span>
    <span class="ml-2">{{ metric.timeFieldLabel | capitalize }}</span>
  </span>
</div>
